import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const appendImages = (imagesData, cards, itemsToDisplay) => {
  const {
    getFiles
  } = imagesData || {};
  if (!getFiles || !cards || !itemsToDisplay) return cards;
  return cards.map(card => {
    const {
      id
    } = card;
    const {
      imageId
    } = itemsToDisplay.find(({
      displayItems
    }) => displayItems[0] === id) || {};
    const image = getFiles.find(({
      id: fileId
    }) => fileId === imageId);
    if (!image) return card;
    return _objectSpread(_objectSpread({}, card), {}, {
      image
    });
  });
};
export default appendImages;
//# sourceMappingURL=append-images.js.map